import EasyInput from "./EasyInput";
export default EasyInput;
